import React, { useState } from "react";
import { Form, Col, Row } from "react-bootstrap";

import apiCalls from "../PowerShadesAPIFunctions";
import User from '../User';
import Button from './Button';

import type { FileUploadProps } from "./types";

const FileUpload = ({
	onSuccess,
	certType,
	entityType,
	entityID,
	disabled = false
}: FileUploadProps) => {
	const [file, setFile] = useState(null);

	const onChange = (e) => {
		const { files } = e.target;
		if (files) {
			setFile(files[0]);
		}
	};

	const uploadFile = async (workingFile) => {
		const formData = new FormData();

		formData.append('avatar', workingFile);
		formData.append('certType', certType);
		formData.append('entityType', entityType);
		formData.append('entityID', entityID ?? "0");
		formData.append('user_jwt', User.getToken());

		const response = await apiCalls.uploadToS3(formData);

		return response;
	};

	const onSubmit = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();
		const res = await uploadFile(file);

		const goods = res.data.url as string;

		onSuccess(goods);
	};

	return (
		<Form className="local-bootstrap">
			<Row className="g-0">
				<Col xs={10}>
					<Form.Control
						disabled={disabled}
						type="file"
						id="custom-file"
						accept="image/*,.pdf"
						onChange={(e) => onChange(e)}
					/>
				</Col>
				<Col xs={2} className="text-end">
					<Button
						onClick={(event) => onSubmit(event)}
						disabled={(disabled && file === null)}
						color={(disabled && file === null) ? "grey" : "green"}
						size="sm"
						className="h-100"
					>
						Upload File
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default FileUpload;
